import React from 'react';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';

import {TextField} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';

import FilterAutocompleteContainer from "./FilterAutocompleteContainer";

FreeTextFilterAutocomplete.propTypes = {
    id: PropTypes.string.isRequired,
    options: PropTypes.array,
    value: PropTypes.string.isRequired,
    onValueChange: PropTypes.func.isRequired,
    placeholderId: PropTypes.string.isRequired,
    onAdd: PropTypes.func.isRequired,
};

function FreeTextFilterAutocomplete({id, options = [], value, onValueChange, placeholderId, onAdd}) {
    const intl = useIntl();

    return (
        <FilterAutocompleteContainer>
            <Autocomplete
                id={id}
                options={options}
                freeSolo
                value={value}
                onChange={(event, newValue) => onValueChange(newValue ?? "")}
                onInputChange={(event, newInputValue) => onValueChange(newInputValue)}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        placeholder={intl.formatMessage({id: placeholderId})}
                        variant="standard"
                        sx={{width: '100%'}}
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: null,
                        }}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                onAdd();
                                e.preventDefault();
                            }
                        }}
                    />
                )}
            />
        </FilterAutocompleteContainer>
    );
}

export default FreeTextFilterAutocomplete;
